import React from "react";
import {connect} from "react-redux";
import {compose} from "redux";
import {translate} from 'react-i18next';
import {Card, Form} from "antd";
import _ from "lodash";
import {
  changeBuilderCategoryForm,
  hideBuilderCategoryFormParentModal,
  showBuilderCategoryFormParentModal,
  submitBuilderCategoryFormCreate,
  submitBuilderCategoryFormEdit
} from "./actions";
import {DCSCategoryForm} from "../../../../components/dcs-category-form";

const mapStateToProps = state => ({
  permissions: state.app.user.permissions,
  category: state.scenes.dataManager.builder.shared.category,
  categorisedCubes: state.scenes.dataManager.builder.shared.categorisedCubes,
  isCategoryFormParentModalVisible: state.scenes.dataManager.builder.shared.isCategoryFormParentModalVisible
});

const mapDispatchToProps = dispatch => ({
  onChange: fields => dispatch(changeBuilderCategoryForm(fields)),
  onCreateSubmit: category => dispatch(submitBuilderCategoryFormCreate(category)),
  onEditSubmit: category => dispatch(submitBuilderCategoryFormEdit(category)),
  onParentModalShow: () => dispatch(showBuilderCategoryFormParentModal()),
  onParentModalHide: () => dispatch(hideBuilderCategoryFormParentModal()),
});

const mapPropsToFields = ({category}) => ({
  CatCode: Form.createFormField({
    value:
      (category !== null && category.CatCode !== undefined)
        ? category.CatCode
        : null
  }),
  ParCode: Form.createFormField({
    value:
      (category !== null && category.ParCode !== undefined)
        ? category.ParCode
        : null
  }),
  labels: Form.createFormField({
    value:
      (category !== null && category.labels !== undefined)
        ? category.labels
        : null
  })
});

const onFieldsChange = ({onChange}, fields) => {
  onChange(_.mapValues(fields, ({value}) => value));
};

const BuilderCategoryForm = ({
                               t,
                               form,
                               permissions,
                               category,
                               categorisedCubes,
                               isCategoryFormParentModalVisible,
                               onCreateSubmit,
                               onEditSubmit,
                               onParentModalShow,
                               onParentModalHide,
                             }) => {

  const disabled = !permissions || !permissions.rules || !permissions.rules.includes("AdminRole");

  return category !== null && category.CatCode !== null && (
    <Card type="inner">
      <DCSCategoryForm
        t={t}
        form={form}
        disabled={disabled}
        onParentModalShow={onParentModalShow}
        isCategoryFormParentModalVisible={isCategoryFormParentModalVisible}
        onParentModalHide={onParentModalHide}
        categorisedCubes={categorisedCubes}
        category={category}
        onEditSubmit={onEditSubmit}
        onCreateSubmit={onCreateSubmit}
      />
    </Card>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
  Form.create({mapPropsToFields, onFieldsChange})
)(BuilderCategoryForm);
